<div class="tickets-mobile">
  <div
    class="ticket"
    *ngFor="let ticket of tickets"
    [attr.color]="ticket.statusColor"
  >
    <div class="item">
      <sh-text size="body-2" color="secondary">
        {{ 'label.creationDate' | translate }}
      </sh-text>
      <span>{{ ticket.creationDate | localizedDate }}</span>
      <sh-badge
        *ngIf="ticket.status === 'Closed'"
        class="badge"
        label="{{ ticket.status }}"
      ></sh-badge>
    </div>
    <div class="item">
      <sh-text size="body-2" color="secondary">
        {{ 'label.ticketNumber' | translate }}
      </sh-text>
      <span class="span-item-ticket-number">
        {{ ticket.ticketNumber }}
        <sh-icon
          button
          size="s"
          id="copyToClipboard"
          class="clipboard-icon"
          icon="copy-results-to-clipboard"
          aria-label="{{ 'spareParts.ariaLabel.copyClipboard' | translate }}"
          (click)="clipboardService.copyToClipboard(ticket.ticketNumber)"
          (keydown.enter)="
            clipboardService.copyToClipboard(ticket.ticketNumber)
          "
          (keydown.backspace)="
            clipboardService.copyToClipboard(ticket.ticketNumber)
          "
        ></sh-icon>
      </span>
    </div>
    <div class="item item--description">
      <sh-text size="body-2" color="secondary">
        {{ 'label.description' | translate }}
      </sh-text>
      <span>{{ ticket.description }}</span>
    </div>
    <div class="item">
      <sh-text size="body-2" color="secondary">
        {{ 'label.TicketstatusFN' | translate }}
      </sh-text>
      <span>
        {{ ticket.operationalState ? ticket.operationalState : UNKNOWN }}
      </span>
    </div>
  </div>
</div>
